import api from "../api/client";

/**
 * Trigger a browser download for a CSV endpoint.
 * Relies on the same axios instance so the httpOnly auth cookie is sent.
 */
export async function downloadCsv(path, params = {}, suggestedName = "export.csv") {
  const { data, headers } = await api.get(path, {
    params,
    responseType: "blob",
  });
  // Try to read filename from Content-Disposition; fall back to suggestedName.
  let filename = suggestedName;
  const cd = headers["content-disposition"];
  if (cd) {
    const m = /filename="?([^"]+)"?/.exec(cd);
    if (m) filename = m[1];
  }
  const url = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
